import { PROJECT_TYPES } from '../constants';
import activ8Actions from './activ8/Activ8ActionsMapping';
import id8Actions from './id8/Id8ActionsMapping';
import resonanceActions from './resonance/resonanceActionsMapping';
import aiStudioActions from './ai-studio/AiStudioActionsMapping';
import storyActions from './story/StoryActionsMapping';

const actionMappings = {
  [PROJECT_TYPES.ID8]: id8Actions,
  [PROJECT_TYPES.RESONANCE]: resonanceActions,
  [PROJECT_TYPES.ACTIV8]: activ8Actions,
  AI_STUDIO: aiStudioActions,
  STORY: storyActions,
};

export default actionMappings;
